module.exports = __webpack_public_path__ + "img/23.843c686e.png";